// --------------------------------------------------------------
// Created On: 2025-04-01
// Author: Hannah Vaughan
//
// Last Modified: 2025-04-02
// Modified By: Hannah Vaughan
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import PropTypes from "prop-types";
import styles from "./RunningStatusControls.module.scss";
import PanelSection from "../PanelSection/PanelSection";
import { CONTROLLER_WORLDWIDE_SOFT_START } from "src/constants/miscellaneous";

// Container for all running status controls for the Running Status section of the Remote Operation Panel.
export default function RunningStatusControls(props: Props): Component {
  return (
    <PanelSection label="Running Status">
      {props.controllerModel !== CONTROLLER_WORLDWIDE_SOFT_START && (
        <div className={`col px-3 ${styles.controlColumn}`}>
          <button
            className="btn btn-success w-100"
            type="button"
            disabled={props.loading}
            onClick={() => props.onChangeRunningStatus("ON")}
          >
            ON
          </button>
        </div>
      )}
      <div className={`col px-3 ${styles.controlColumn}`}>
        <button
          className="btn btn-danger w-100"
          type="button"
          disabled={props.loading}
          onClick={() => props.onChangeRunningStatus("OFF")}
        >
          OFF
        </button>
      </div>
    </PanelSection>
  );
}

RunningStatusControls.propTypes = {
  controllerModel: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  onChangeRunningStatus: PropTypes.func.isRequired,
};

interface Props {
  controllerModel: string;
  loading: boolean;
  onChangeRunningStatus: (runningStatus: string) => void;
}
